module.exports = __webpack_public_path__ + "img/file.23eae880.svg";